import React from 'react'

const ArrowDownIcon = (props) => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7"><path d="M5 6.986l-.014.014-2.148-2.1.014-.015-2.852-2.787 2.148-2.1 2.851 2.787 2.849-2.787 2.151 2.1-2.852 2.787.014.015-2.148 2.1z" fill={props.fill}/></svg>
	)
}

export default ArrowDownIcon